import { Button, Checkbox, Input, message } from 'antd';
import Form, { FormComponentProps } from 'antd/lib/form';
import FormItem from 'antd/lib/form/FormItem';
import * as React from 'react';
import injectSheet from 'react-jss';
import { connect, ConnectedProps } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateFinancingCtaVisibilityStatus } from 'src/actions/loadInitialData';
import { postFinancingRequiredFormData } from 'src/api/hubspot/hubspot';
import { FinancingOptionsServiceProvider, FinancingOptionsShipper, OrgTypes } from 'src/Library/Constants';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import './GetFinancingNowForm.css'

const styles = theme => ({
    container:{
        padding: '16px'
    },
    form: {
        marginTop: '12px'
    },
    heading: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 600
    },
    formItem: {
        '&.ant-form-item': {
            marginBottom: '10px',
        },
        '&.ant-form-item-label': {
            lineHeight: '16px',
        },
        fontSize: '12px'
    },
    label: {
        fontWeight: 600
    },
    submitDiv: {
        textAlign: 'center'
    }
});

const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

interface IProps extends FormComponentProps, StylesProps<ReturnType<typeof styles>>, PropsFromRedux {
    handleCloseClick: () => void;
    updateFinancingCtaVisibilityStatus: () => any;
}

interface State {
    isLoading: boolean;
}
const GetFinancingNowForm: React.FC<IProps> = (props) => {

    const {
        classes,
        userData,
        type,
        form,
        handleCloseClick,
        updateFinancingCtaVisibilityStatus
    } = props;

    const { getFieldDecorator, setFieldsValue, validateFields, getFieldValue } = form;

    const [state, setState] = useGenericState<State>({
        isLoading: false
    });

    const { isLoading } = state;
    const renderInputField = (label: string, formKey: string, initialValue: string | undefined, required: boolean = false, inputType: string = 'text') => {
        return (
                <FormItem 
                className={classes.formItem}

                label={<span className={classes.label}>{label}</span>}
                labelAlign='left'>
                    {getFieldDecorator(formKey, {
                        rules: [
                            required ? { required: true, message: <span>Required</span> } : {},
                        ],
                        initialValue: initialValue,
                    })(
                        <Input type={inputType} disabled={initialValue ? true : undefined}/>
                    )}
                </FormItem>
        );
    }

    const renderFinancingRequiredShipper = () => {
        return (
        <FormItem 
        className={classes.formItem}
        labelAlign='left'
        label={<span className={classes.label}>Financing Required</span>}>
            {getFieldDecorator('financingRequiredShipper', {
                        rules: [
                            { required: true, message: <span>Required</span> },
                        ]
                    })(
            <Checkbox.Group>
                <Checkbox value={FinancingOptionsShipper.FREIGHT_FINANCING}>
                Freight Financing
                </Checkbox>
                <Checkbox value={FinancingOptionsShipper.INVOICE_FINANCING}>
                Invoice Financing
                </Checkbox>
            </Checkbox.Group>
            )}
        </FormItem>
        );
    }

    const renderFinancingRequiredFF = () => {
        return (
        <FormItem 
        className={classes.formItem}
        label={<span className={classes.label}>Financing Required</span>}
        labelAlign='left'>
            {getFieldDecorator('financingRequiredFF',  {
                        rules: [
                            { required: true, message: <span>Required</span> },
                        ]
                    })(
            <Checkbox.Group>
                <Checkbox value={FinancingOptionsServiceProvider.FREIGHT_FACTORING}>
                Freight Invoice Factoring
                </Checkbox>
                <Checkbox style={{marginLeft:'0px'}} value={FinancingOptionsServiceProvider.EARLY_PAYMENT_TO_SUPPLIERS}>
                Early Payment To Suppliers
                </Checkbox>
            </Checkbox.Group>
            )}
        </FormItem>
        );
    }

    const getHubspotRequestPayload = (values: Record<string, any>) => {
        const fields = [
              {
                  objectTypeId: "0-1",
                  name: "firstname",
                  value:  values?.name || '',
              },
              {
                  objectTypeId: "0-1",
                  name: "email",
                  value: values?.email || '',
              },
              {
                  objectTypeId: "0-1",
                  name: "phone",
                  value: values?.phone || '',
              },
              {
                  objectTypeId: "0-1",
                  name: "company",
                  value: values?.companyName || '',
              },
              {
                  objectTypeId: "0-1",
                  name: "amount_required",
                  value: values?.amountRequired || '',
              },
              {
                  objectTypeId: "0-1",
                  name: "importer_exporter_code__iec_",
                  value: values?.iec || '',
              },     
            ];
            
          if (type === OrgTypes.SHIPPER) {
            fields.push(
                {
                objectTypeId: "0-1",
                name: "financing_required___shipper",
                value: values?.financingRequiredShipper?.toString() || '',
                }
            );
          } else {
            fields.push(
            {
                objectTypeId: "0-1",
                name: "financing_required___ff",
                value: values?.financingRequiredFF?.toString() || '',
            }
            );
          }

        return { fields };
    }

    const handleFormSubmit = () => {
        validateFields(async (err, values) => {
            if (err) {
              return;
            }
            const hubspotRequestPayload = getHubspotRequestPayload(values);
            setState({
                isLoading: true
            });
            const response = await postFinancingRequiredFormData(hubspotRequestPayload, type);
            if (response.isSuccess) {
                setState({
                    isLoading: false
                });
                updateFinancingCtaVisibilityStatus();
                message.success('Thank You! We have received your request.')
                handleCloseClick();
            } else {
                setState({
                    isLoading: false
                });
                message.error(response.errorMessage);
            }
;            
        });
    }

    return (
        <div className={classes.container}>
            <div className={classes.heading}>
                Submit the form below to reach out to us and get your
                online loan application started!
            </div>

            <div className={classes.form}>
                <Form {...formItemLayout}>
                    {renderInputField('Name', 'name', userData?.name, true)}
                    {renderInputField('E-mail', 'email', userData?.email, true)}
                    {renderInputField('Company name', 'companyName', userData?.organisation_id, true)}
                    {renderInputField('Phone', 'phone', undefined, false, 'number')}
                    {type === OrgTypes.SHIPPER && renderFinancingRequiredShipper()}
                    {type !== OrgTypes.SHIPPER && renderFinancingRequiredFF()}
                    {renderInputField('Amount Required (INR)', 'amountRequired', undefined, true, 'number')}
                    {renderInputField('Importer Exporter Code (IEC)', 'iec', undefined, false)}
                    <div className={classes.submitDiv}>
                        <Button loading={isLoading} onClick={handleFormSubmit} type='primary' htmlType='submit' disabled={isLoading}>Submit</Button>
                    </div>
                </Form>
            </div>
        </div>
    );
}

const mapStateToProps = ({ masterData }) => ({
  userData: masterData.userData,
  type : masterData.userData.type,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateFinancingCtaVisibilityStatus
}, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(injectSheet(styles)(Form.create()(GetFinancingNowForm)));
